import { Config } from './config.type'
const config: Config  = {
    "build": {
        "host": "https://graphql0.canvasflow.io",
        "subdirectory": "/",
        "website": "",
        "assetDirectory": "/",
        "title": "Smartmags",
        "shortTitle": "Smartmags",
        "appKey": "3b61d11f-1f41-4ecd-8a75-65c3ef105a69",
        "language": "en",
        "languages": [
            "en"
        ],
        "about": "<p><a href=\"https://accelerate360.com/terms-and-conditions/\" target=\"_blank\" rel=\"noreferrer\">Terms of Use</a></p><p><a href=\"https://accelerate360.com/business-services/a360-media/privacy-policy/\" target=\"_blank\" rel=\"noreferrer\">Privacy Policy</a></p><p><div class=\"optanon-toggle-display\" style=\"margin: 0px 10px;\">Do Not Sell</div></p><p><a href=\"https://accelerate360.com/business-services/a360-media/cookie-policy/\" target=\"_blank\" rel=\"noreferrer\">Cookie Policy</a></p>",
        "buildNumber": 909698,
        "buildDate": "2025-06-04T02:33:56.177Z",
        "version": "2.10.4"
    },
    "app": {
        "contentProtection": false,
        "admin": true,
        "favorite": false,
        "auth": {
            "enabled": true,
            "type": "cognito",
            "config": {
                "host": "https://auth.smartmags.com",
                "clientId": "5jqmfhfpc46ktk12ioonfh0teg",
                "customerPortalUrl": "https://billing.stripe.com/p/login/test_9B614n3cx1Rrdv77Od4Rq00"
            }
        },
        "hideNavbarOnScroll": false,
        "installationOption": {
            "enabled": false
        },
        "password": {
            "enabled": false,
            "value": ""
        },
        "template": {
            "type": "magazine",
            "config": {
                "featureArticles": true
            }
        },
        "legal": {
            "tou": {
                "url": "https://accelerate360.com/terms-and-conditions/",
                "label": "Terms of Use"
            },
            "privacy": {
                "url": "https://accelerate360.com/business-services/a360-media/privacy-policy/",
                "label": "Privacy Policy"
            },
            "cookie": {
                "url": "https://accelerate360.com/business-services/a360-media/cookie-policy/",
                "label": "Cookie Policy"
            }
        },
        "cache": {
            "ttl": {
                "getAllIssues": 1,
                "previewIssue": 1,
                "getIssue": 1,
                "getFeatureArticles": 1,
                "styles": 1
            }
        }
    },
    "issue": {
        "contentType": "responsive-replica",
        "lastLocation": {
            "enabled": false
        }
    },
    "analytics": {
        "tealium": {
            "ChannelID": "",
            "pageType": "",
            "pageDetail": "",
            "pageTemplate": "",
            "projectType": "",
            "url": ""
        },
        "google": {
            "trackerID": "",
            "sampleRate": 0
        },
        "ga4": {
            "trackerID": "",
            "sampleRate": 1
        },
        "gtm": {
            "trackerID": ""
        },
        "googleOptimize": {
            "trackerID": ""
        },
        "onetrust": {
            "id": ""
        },
        "caymland": {
            "domain": ""
        },
        "ackee": {
            "domainId": "",
            "server": ""
        },
        "netstats": {
            "trackerID": ""
        },
        "hotjar": {
            "trackerID": ""
        },
        "hubspot": {
            "trackerID": ""
        },
        "ShareThis": {
            "trackerID": ""
        },
        "cookiefirst": {
            "key": ""
        },
        "cookiehub": {
            "trackerID": ""
        },
        "plausible": {
            "domain": ""
        },
        "matomo": {
            "domain": ""
        }
    }
};
export default config;